<template>
    <span class="fullscreen-toggle">
        <a
            class="map-button"
            :class="{
                enter__fullscreen: !isFullscreen,
                exit__fullscreen: isFullscreen,
            }"
            href="#"
            title="Fullscreen"
            role="button"
            aria-label="Fullscreen"
            :data-test-id="isFullscreen ? 'map-exit-fullscreen-button' : 'map-enter-fullscreen-button'"
            @click.prevent="toggleFullscreen"
        />
    </span>
</template>

<script>
export default {
    props: {
        mapObj: {
            type: Object,
            default: () => {},
        },
        mapContainer: {
            type: undefined,
            required: true,
        },
    },

    data() {
        return {
            isFullscreen: false,
        }
    },

    mounted() {
        document.addEventListener('fullscreenchange', () => this.handleFSListener(0))
        document.addEventListener('webkitfullscreenchange', () => this.handleFSListener(1))
        document.addEventListener('MSFullscreenChange', () => this.handleFSListener(2))
    },

    beforeUnmount() {
        document.removeEventListener('fullscreenchange', () => this.handleFSListener(0))
        document.removeEventListener('webkitfullscreenchange', () => this.handleFSListener(1))
        document.removeEventListener('MSFullscreenChange', () => this.handleFSListener(2))
    },

    methods: {
        toggleFullscreen() {
            if (this.isFullScreen()) {
                this.exitFullScreen()
            } else {
                this.enterFullScreen()
            }
        },

        isFullScreen() {
            return document.fullscreenElement || document.webkitIsFullScreen || document.msFullscreenElement
        },

        exitFullScreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen()
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen()
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen()
            }
        },

        enterFullScreen() {
            if (this.mapContainer.requestFullscreen) {
                this.mapContainer.requestFullscreen()
            } else if (this.mapContainer.webkitRequestFullscreen) {
                this.mapContainer.webkitRequestFullscreen()
            } else if (this.mapContainer.msRequestFullscreen) {
                this.mapContainer.msRequestFullscreen()
            }
        },

        handleFSListener(type) {
            // 0 for Chrome & Firefox
            // 1 for Safari
            // 2 for IE
            if (type === 0) {
                this.isFullscreen = !!document.fullscreenElement
            } else if (type === 1 || type === 2) {
                if (document.webkitIsFullScreen || document.msFullscreenElement) {
                    this.isFullscreen = true
                    this.mapContainer.classList.add('map-container--fullscreen')
                    this.mapObj.mapObject.invalidateSize()
                } else {
                    this.isFullscreen = false
                    this.mapContainer.classList.remove('map-container--fullscreen')
                }
            }
        },
    },
}
</script>
